var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carouselBar"},[_c('el-carousel',_vm._l((_vm.carouselList),function(v,i){return _c('el-carousel-item',{key:i},[_c('img',{attrs:{"src":v.url,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }